module.exports = __webpack_public_path__ + "img/world-map-4.18d66028.jpg";